import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { CategorisDataType } from "../../../../interfaces/admin.interface";
import { CategoriesService } from "../../../../services/categories.service";

interface CategorySelectProps {
  setFieldValue: (field: string, value: any) => void;
  categroryName?: any;
  selectedCategoryId: string | null;
  setSelectedCategoryId: (value: string | null) => void;
}
const SelectCategory: React.FC<CategorySelectProps> = ({
  setFieldValue,
  categroryName,
  selectedCategoryId,
  setSelectedCategoryId,
}) => {
  const [categories, setCategories] = useState<CategorisDataType[]>([]);
  const [childCategories, setChildCategories] = useState<
    Record<string, CategorisDataType[]>
  >({});
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    CategoriesService.getAllCategoreis()
      .then((response) => {
        if (Array.isArray(response?.data)) {
          setCategories(response?.data);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const toggleRow = (key: string) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getChildCategory = (parentId: string) => {
    if (childCategories[parentId]) return;

    CategoriesService.getCategoryChild(parentId).then((response) => {
      if (response?.data) {
        setChildCategories((prev) => ({
          ...prev,
          [parentId]: response?.data.filter(
            (child: any) =>
              !prev[parentId]?.some((existing) => existing.id === child.id)
          ),
        }));
      }
    });
  };

  const handleCategoryChange = (value: string) => {
    setSelectedCategoryId(value);
    setFieldValue("category_id", value);
  };

  const renderCategories = (parentId: any | null, depth: number = 0) => {
    const parentCategories = categories
      .filter((category) => category.parent_id === parentId)
      .concat(childCategories[parentId] || []);

    if (!parentCategories.length) return null;

    return parentCategories.map((category, index) => {
      const categoryKey = `${category.id}`;
      const isExpanded = expandedRows[categoryKey];

      return (
        <React.Fragment key={index}>
          <Select.Option
            key={category.id}
            value={category.id}
            style={{ paddingLeft: `${depth * 15}px` }}
          >
            {category.is_parent || category.parent_id === null ? (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  toggleRow(categoryKey);
                  if (!isExpanded) {
                    getChildCategory(category.id.toString());
                  }
                }}
              >
                {isExpanded ? "-" : "+"} {category.name}
              </span>
            ) : (
              `${" ".repeat(depth * 2)}${category.name}`
            )}
          </Select.Option>
          {isExpanded && renderCategories(category.id, depth + 1)}
        </React.Fragment>
      );
    });
  };

  return (
    <Select
      style={{ width: "100%", height: "48px" }}
      id="id"
      placeholder={loading ? "Kateqoriyalar yüklənir..." : "Kateqoriya seçin"}
      value={selectedCategoryId || categroryName}
      onChange={handleCategoryChange}
    >
      {renderCategories(null)}
    </Select>
  );
};

export default SelectCategory;
